unit View.Data_Base_Logs.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UHelperServer, System.StrUtils, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces, UConstantes, UUtils;

type
  TFViewData_Base_LogsList = class(TForm)
    Data_Base_LogsDataset: TXDataWebDataSet;
    Data_Base_LogsDatasetid: TIntegerField;
    Data_Base_LogsDatasetstatus: TStringField;
    Data_Base_LogsDatasettransacao_inicial: TStringField;
    Data_Base_LogsDatasettransacao_final: TStringField;
    Data_Base_LogsDatasetdata_coleta_log: TDateTimeField;
    Data_Base_LogsDatasetsweep_executado: TBooleanField;
    Data_Base_LogsDatasettempo_gasto_sweep: TStringField;
    Data_Base_LogsDatasetdescricao: TStringField;
    Data_Base_LogsDatasetinclusao: TDateTimeField;
    Data_Base_LogsDatasetalteracao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    Data_Base_LogsDatasetdiferenca_transacao: TLargeintField;
    btnExportarExcel: TButton;
    tmrConsulta: TTimer;
    Data_Base_LogsDatasetdbaliadoNome_Fantasia: TStringField;
    Data_Base_LogsDatasetdbaliadoCNPJ: TStringField;
    Data_Base_LogsDatasetdbpath: TStringField;
    edtAliadoNome: TEdit;
    btnPesquisarAliado: TButton;
    cbbSweepExecutado: TComboBox;
    Data_Base_LogsDatasetlog_gfix: TMemoField;
    Data_Base_LogsDatasetlog_sweep: TMemoField;
    cbbStatus: TComboBox;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure Data_Base_LogsDatasetstatusGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasetdescricaoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasettransacao_inicialGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasettransacao_finalGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure Data_Base_LogsDatasetdiferenca_transacaoGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
    procedure btnExportarExcelClick(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure Data_Base_LogsDatasetdbaliadoCNPJGetText(Sender: TField;
      var Text: string; DisplayText: Boolean);
    [async]
    procedure btnPesquisarAliadoClick(Sender: TObject); async;
    procedure cbbSweepExecutadoChange(Sender: TObject);
    procedure cbbStatusChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;

    function GetFiltro : string;
    procedure Filtrar;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewData_Base_LogsList: TFViewData_Base_LogsList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewData_Base_LogsList }

procedure TFViewData_Base_LogsList.btnExportarExcelClick(Sender: TObject);
begin
  TUtils.ExportarDadosExcel(Data_Base_LogsDataset, WebDBTableControl1,
    FGridPlugin.FDatasetPlugin.FDataset.QueryString, FGridPlugin.FQuantidadeRegistrosBusca);
end;

procedure TFViewData_Base_LogsList.btnPesquisarAliadoClick(Sender: TObject);
var
  lBackupTag : Integer;
begin
  lBackupTag := edtAliadoNome.Tag;

  Await(THelperServer.ChamarConsulta('Aliados', 'Aliado', edtAliadoNome));

  if lBackupTag <> edtAliadoNome.Tag then
    Filtrar;
end;

procedure TFViewData_Base_LogsList.cbbStatusChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewData_Base_LogsList.cbbSweepExecutadoChange(Sender: TObject);
begin
  Filtrar;
end;

procedure TFViewData_Base_LogsList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewData_Base_LogsList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewData_Base_LogsList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewData_Base_LogsList, AElementID, Result, @AfterCreate);
end;

procedure TFViewData_Base_LogsList.Data_Base_LogsDatasetdbaliadoCNPJGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := TUtils.FormatarCnpj_Cpf(Sender.AsString);
end;

procedure TFViewData_Base_LogsList.Data_Base_LogsDatasetdescricaoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := THelperServer.GetTextoMax100Caracteres(Sender.AsString.ToUpper);
end;

procedure TFViewData_Base_LogsList.Data_Base_LogsDatasetdiferenca_transacaoGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
    Text := THelperServer.FormatarNumeroBigInt(StrToInt64(Sender.AsString));
end;

procedure TFViewData_Base_LogsList.Data_Base_LogsDatasetstatusGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  Text := Sender.AsString.ToUpper;
end;

procedure TFViewData_Base_LogsList.Data_Base_LogsDatasettransacao_finalGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
    Text := THelperServer.FormatarNumeroBigInt(StrToInt64(Sender.AsString));
end;

procedure TFViewData_Base_LogsList.Data_Base_LogsDatasettransacao_inicialGetText(
  Sender: TField; var Text: string; DisplayText: Boolean);
begin
  if not Sender.AsString.IsEmpty then
    Text := THelperServer.FormatarNumeroBigInt(StrToInt64(Sender.AsString));
end;

procedure TFViewData_Base_LogsList.edSearchKeyDown(Sender: TObject;
  var Key: Word; Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewData_Base_LogsList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewData_Base_LogsList.Filtrar;
begin
  FGridPlugin.FDatasetPlugin.FFilterPadrao := Trim(GetFiltro);
  FGridPlugin.Load;
end;

function TFViewData_Base_LogsList.GetFiltro: string;
var
  lListaFiltro : TStringList;
begin
  Result := EmptyStr;

  lListaFiltro := TStringList.Create;

  try
    if edtAliadoNome.Tag <> 0 then
      lListaFiltro.Add('(db.aliado.id eq '+edtAliadoNome.Tag.ToString+')');

    if cbbSweepExecutado.ItemIndex = 1 then
      lListaFiltro.Add('(sweep_executado eq true)')
    else if cbbSweepExecutado.ItemIndex = 2 then
      lListaFiltro.Add('(sweep_executado eq false)');

    if cbbStatus.ItemIndex > 0 then
      lListaFiltro.Add('(status eq '+QuotedStr(cbbStatus.Text)+')');

    if lListaFiltro.Count > 0 then
      Result := string.Join(' and ', lListaFiltro.ToStringArray);
  finally
    if Assigned(lListaFiltro) then
      FreeAndNil(lListaFiltro)
  end;
end;

procedure TFViewData_Base_LogsList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewData_Base_LogsList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Data_Base_LogsDataset.Connection.Model.DefaultSchema.FindEntityType(Data_Base_LogsDataset.EntitySetName),
      Data_Base_LogsDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-bs-toggle', 'tooltip');
    Button.ElementHandle.setAttribute('title', 'Ver log');
    Button.ElementHandle.setAttribute('data-test', 'btn_ver_data_base_log');
  end;
end;

procedure TFViewData_Base_LogsList.WebDBTableControl1GetCellClass(
  Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string;
  var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['db.aliado.Nome_Fantasia', 'db.aliado.CNPJ',
      'db.path', 'descricao', 'transacao_inicial', 'transacao_final', 'diferenca_transacao']) of
      0, 1, 2, 3 : AClassName := 'text-start';
      4, 5, 6 : AClassName := 'text-end';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewData_Base_LogsList.WebDBTableControl1GetCellData(
  Sender: TObject; ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow > 0 then
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['sweep_executado',
      'status']) of
      0:
      begin
        if AValue = 'True' then
          AValue := '<i class="fas fa-check text-success"><i>'
        else if AValue = 'False' then
          AValue := '<i class="fas fa-times text-danger"><i>'
      end;
      1:
      begin
        if AValue.IsEmpty then
          Exit;

        if AValue.ToUpper = 'OK' then
          AValue := '<div class="rounded-pill" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">OK</div>'
        else if AValue.ToUpper = 'ALERTA' then
          AValue := '<div class="rounded-pill" style="background-color: #ffad46;color:white; padding-right: 5px;padding-left: 5px;">ALERTA</div>'
        else if AValue.ToUpper = 'CRITICO' then
          AValue := '<div class="rounded-pill" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">CRÍTICO</div>'
        else
          AValue := '<div class="rounded-pill text-center" style="background-color: #1C1C1C;color:white; padding-right: 5px;padding-left: 5px;">'+AValue.ToUpper+'</div>';
      end;
    end;
  end;
end;

procedure TFViewData_Base_LogsList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('data_base_logs', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, Data_Base_LogsDataset, lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'data_coleta_log desc';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewData_Base_LogsList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.data_base_logs.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.data_base_logs.list.table');
  cbPageSize := TComboBox.Create('view.data_base_logs.list.cbPageSize');
  edSearch := TEdit.Create('view.data_base_logs.list.search');
  lcPaginator := TListControl.Create('view.data_base_logs.list.pagination');
  btnExportarExcel := TButton.Create('btnExportarExcel');
  edtAliadoNome := TEdit.Create('edtAliadoNome');
  btnPesquisarAliado := TButton.Create('btnPesquisarAliado');
  cbbSweepExecutado := TComboBox.Create('cbbSweepExecutado');
  cbbStatus := TComboBox.Create('cbbStatus');
  Data_Base_LogsDataset := TXDataWebDataSet.Create(Self);
  Data_Base_LogsDatasetdbaliadoNome_Fantasia := TStringField.Create(Self);
  Data_Base_LogsDatasetdbaliadoCNPJ := TStringField.Create(Self);
  Data_Base_LogsDatasetstatus := TStringField.Create(Self);
  Data_Base_LogsDatasettransacao_inicial := TStringField.Create(Self);
  Data_Base_LogsDatasettransacao_final := TStringField.Create(Self);
  Data_Base_LogsDatasetdiferenca_transacao := TLargeintField.Create(Self);
  Data_Base_LogsDatasetdata_coleta_log := TDateTimeField.Create(Self);
  Data_Base_LogsDatasetsweep_executado := TBooleanField.Create(Self);
  Data_Base_LogsDatasettempo_gasto_sweep := TStringField.Create(Self);
  Data_Base_LogsDatasetdescricao := TStringField.Create(Self);
  Data_Base_LogsDatasetdbpath := TStringField.Create(Self);
  Data_Base_LogsDatasetlog_gfix := TMemoField.Create(Self);
  Data_Base_LogsDatasetlog_sweep := TMemoField.Create(Self);
  Data_Base_LogsDatasetinclusao := TDateTimeField.Create(Self);
  Data_Base_LogsDatasetalteracao := TDateTimeField.Create(Self);
  Data_Base_LogsDatasetid := TIntegerField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  btnExportarExcel.BeforeLoadDFMValues;
  edtAliadoNome.BeforeLoadDFMValues;
  btnPesquisarAliado.BeforeLoadDFMValues;
  cbbSweepExecutado.BeforeLoadDFMValues;
  cbbStatus.BeforeLoadDFMValues;
  Data_Base_LogsDataset.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdbaliadoNome_Fantasia.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdbaliadoCNPJ.BeforeLoadDFMValues;
  Data_Base_LogsDatasetstatus.BeforeLoadDFMValues;
  Data_Base_LogsDatasettransacao_inicial.BeforeLoadDFMValues;
  Data_Base_LogsDatasettransacao_final.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdiferenca_transacao.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdata_coleta_log.BeforeLoadDFMValues;
  Data_Base_LogsDatasetsweep_executado.BeforeLoadDFMValues;
  Data_Base_LogsDatasettempo_gasto_sweep.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdescricao.BeforeLoadDFMValues;
  Data_Base_LogsDatasetdbpath.BeforeLoadDFMValues;
  Data_Base_LogsDatasetlog_gfix.BeforeLoadDFMValues;
  Data_Base_LogsDatasetlog_sweep.BeforeLoadDFMValues;
  Data_Base_LogsDatasetinclusao.BeforeLoadDFMValues;
  Data_Base_LogsDatasetalteracao.BeforeLoadDFMValues;
  Data_Base_LogsDatasetid.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewData_Base_LogsList';
    Width := 550;
    Height := 402;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 320;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'db.aliado.Nome_Fantasia';
      Title := 'Aliado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'db.aliado.CNPJ';
      Title := 'Cnpj';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'transacao_inicial';
      Title := 'Trans. Inicial';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'transacao_final';
      Title := 'Trans. Final';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'diferenca_transacao';
      Title := 'Dif. Trans.';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_coleta_log';
      Title := 'Coleta Log';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sweep_executado';
      Title := 'Sweep Executado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tempo_gasto_sweep';
      Title := 'Tempo Sweep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'descricao';
      Title := 'Descri'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'db.path';
      Title := 'Caminho DB';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 309;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    btnExportarExcel.SetParentComponent(Self);
    btnExportarExcel.Name := 'btnExportarExcel';
    btnExportarExcel.Left := 8;
    btnExportarExcel.Top := 355;
    btnExportarExcel.Width := 96;
    btnExportarExcel.Height := 25;
    btnExportarExcel.Caption := 'Exportar Excel';
    btnExportarExcel.ChildOrder := 11;
    btnExportarExcel.HeightPercent := 100.000000000000000000;
    btnExportarExcel.WidthPercent := 100.000000000000000000;
    SetEvent(btnExportarExcel, Self, 'OnClick', 'btnExportarExcelClick');
    edtAliadoNome.SetParentComponent(Self);
    edtAliadoNome.Name := 'edtAliadoNome';
    edtAliadoNome.Left := 125;
    edtAliadoNome.Top := 357;
    edtAliadoNome.Width := 124;
    edtAliadoNome.Height := 22;
    edtAliadoNome.ChildOrder := 21;
    edtAliadoNome.Enabled := False;
    edtAliadoNome.HeightPercent := 100.000000000000000000;
    edtAliadoNome.WidthPercent := 100.000000000000000000;
    btnPesquisarAliado.SetParentComponent(Self);
    btnPesquisarAliado.Name := 'btnPesquisarAliado';
    btnPesquisarAliado.Left := 251;
    btnPesquisarAliado.Top := 357;
    btnPesquisarAliado.Width := 30;
    btnPesquisarAliado.Height := 21;
    btnPesquisarAliado.ChildOrder := 22;
    btnPesquisarAliado.HeightPercent := 100.000000000000000000;
    btnPesquisarAliado.WidthPercent := 100.000000000000000000;
    SetEvent(btnPesquisarAliado, Self, 'OnClick', 'btnPesquisarAliadoClick');
    cbbSweepExecutado.SetParentComponent(Self);
    cbbSweepExecutado.Name := 'cbbSweepExecutado';
    cbbSweepExecutado.Left := 304;
    cbbSweepExecutado.Top := 357;
    cbbSweepExecutado.Width := 113;
    cbbSweepExecutado.Height := 21;
    cbbSweepExecutado.HeightPercent := 100.000000000000000000;
    cbbSweepExecutado.TabStop := False;
    cbbSweepExecutado.Text := 'TODOS';
    cbbSweepExecutado.WidthPercent := 100.000000000000000000;
    SetEvent(cbbSweepExecutado, Self, 'OnChange', 'cbbSweepExecutadoChange');
    cbbSweepExecutado.ItemIndex := 0;
    cbbSweepExecutado.Items.BeginUpdate;
    try
      cbbSweepExecutado.Items.Clear;
      cbbSweepExecutado.Items.Add('TODOS');
      cbbSweepExecutado.Items.Add('SIM');
      cbbSweepExecutado.Items.Add('N'#195'O');
    finally
      cbbSweepExecutado.Items.EndUpdate;
    end;
    cbbStatus.SetParentComponent(Self);
    cbbStatus.Name := 'cbbStatus';
    cbbStatus.Left := 429;
    cbbStatus.Top := 357;
    cbbStatus.Width := 113;
    cbbStatus.Height := 21;
    cbbStatus.HeightPercent := 100.000000000000000000;
    cbbStatus.TabStop := False;
    cbbStatus.Text := 'TODOS';
    cbbStatus.WidthPercent := 100.000000000000000000;
    SetEvent(cbbStatus, Self, 'OnChange', 'cbbStatusChange');
    cbbStatus.ItemIndex := 0;
    cbbStatus.Items.BeginUpdate;
    try
      cbbStatus.Items.Clear;
      cbbStatus.Items.Add('TODOS');
      cbbStatus.Items.Add('OK');
      cbbStatus.Items.Add('ALERTA');
      cbbStatus.Items.Add('CR'#205'TICO');
      cbbStatus.Items.Add('RESTORE');
    finally
      cbbStatus.Items.EndUpdate;
    end;
    Data_Base_LogsDataset.SetParentComponent(Self);
    Data_Base_LogsDataset.Name := 'Data_Base_LogsDataset';
    Data_Base_LogsDataset.EntitySetName := 'Data_Base_Logs';
    Data_Base_LogsDataset.Connection := DMConnection.ApiConnection;
    Data_Base_LogsDataset.Left := 72;
    Data_Base_LogsDataset.Top := 88;
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.Name := 'Data_Base_LogsDatasetdbaliadoNome_Fantasia';
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.FieldName := 'db.aliado.Nome_Fantasia';
    Data_Base_LogsDatasetdbaliadoCNPJ.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdbaliadoCNPJ.Name := 'Data_Base_LogsDatasetdbaliadoCNPJ';
    Data_Base_LogsDatasetdbaliadoCNPJ.FieldName := 'db.aliado.CNPJ';
    SetEvent(Data_Base_LogsDatasetdbaliadoCNPJ, Self, 'OnGetText', 'Data_Base_LogsDatasetdbaliadoCNPJGetText');
    Data_Base_LogsDatasetstatus.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetstatus.Name := 'Data_Base_LogsDatasetstatus';
    Data_Base_LogsDatasetstatus.FieldName := 'status';
    SetEvent(Data_Base_LogsDatasetstatus, Self, 'OnGetText', 'Data_Base_LogsDatasetstatusGetText');
    Data_Base_LogsDatasetstatus.Size := 255;
    Data_Base_LogsDatasettransacao_inicial.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasettransacao_inicial.Name := 'Data_Base_LogsDatasettransacao_inicial';
    Data_Base_LogsDatasettransacao_inicial.FieldName := 'transacao_inicial';
    SetEvent(Data_Base_LogsDatasettransacao_inicial, Self, 'OnGetText', 'Data_Base_LogsDatasettransacao_inicialGetText');
    Data_Base_LogsDatasettransacao_inicial.Size := 255;
    Data_Base_LogsDatasettransacao_final.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasettransacao_final.Name := 'Data_Base_LogsDatasettransacao_final';
    Data_Base_LogsDatasettransacao_final.FieldName := 'transacao_final';
    SetEvent(Data_Base_LogsDatasettransacao_final, Self, 'OnGetText', 'Data_Base_LogsDatasettransacao_finalGetText');
    Data_Base_LogsDatasettransacao_final.Size := 255;
    Data_Base_LogsDatasetdiferenca_transacao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdiferenca_transacao.Name := 'Data_Base_LogsDatasetdiferenca_transacao';
    Data_Base_LogsDatasetdiferenca_transacao.Tag := 3;
    Data_Base_LogsDatasetdiferenca_transacao.FieldName := 'diferenca_transacao';
    SetEvent(Data_Base_LogsDatasetdiferenca_transacao, Self, 'OnGetText', 'Data_Base_LogsDatasetdiferenca_transacaoGetText');
    Data_Base_LogsDatasetdata_coleta_log.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdata_coleta_log.Name := 'Data_Base_LogsDatasetdata_coleta_log';
    Data_Base_LogsDatasetdata_coleta_log.FieldName := 'data_coleta_log';
    Data_Base_LogsDatasetdata_coleta_log.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Data_Base_LogsDatasetsweep_executado.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetsweep_executado.Name := 'Data_Base_LogsDatasetsweep_executado';
    Data_Base_LogsDatasetsweep_executado.FieldName := 'sweep_executado';
    Data_Base_LogsDatasettempo_gasto_sweep.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasettempo_gasto_sweep.Name := 'Data_Base_LogsDatasettempo_gasto_sweep';
    Data_Base_LogsDatasettempo_gasto_sweep.FieldName := 'tempo_gasto_sweep';
    Data_Base_LogsDatasettempo_gasto_sweep.Size := 255;
    Data_Base_LogsDatasetdescricao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdescricao.Name := 'Data_Base_LogsDatasetdescricao';
    Data_Base_LogsDatasetdescricao.FieldName := 'descricao';
    SetEvent(Data_Base_LogsDatasetdescricao, Self, 'OnGetText', 'Data_Base_LogsDatasetdescricaoGetText');
    Data_Base_LogsDatasetdescricao.Size := 255;
    Data_Base_LogsDatasetdbpath.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetdbpath.Name := 'Data_Base_LogsDatasetdbpath';
    Data_Base_LogsDatasetdbpath.Tag := 3;
    Data_Base_LogsDatasetdbpath.FieldName := 'db.path';
    Data_Base_LogsDatasetlog_gfix.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetlog_gfix.Name := 'Data_Base_LogsDatasetlog_gfix';
    Data_Base_LogsDatasetlog_gfix.Tag := 3;
    Data_Base_LogsDatasetlog_gfix.FieldName := 'log_gfix';
    Data_Base_LogsDatasetlog_gfix.BlobType := ftMemo;
    Data_Base_LogsDatasetlog_gfix.Size := 65536;
    Data_Base_LogsDatasetlog_sweep.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetlog_sweep.Name := 'Data_Base_LogsDatasetlog_sweep';
    Data_Base_LogsDatasetlog_sweep.Tag := 3;
    Data_Base_LogsDatasetlog_sweep.FieldName := 'log_sweep';
    Data_Base_LogsDatasetlog_sweep.BlobType := ftMemo;
    Data_Base_LogsDatasetlog_sweep.Size := 65536;
    Data_Base_LogsDatasetinclusao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetinclusao.Name := 'Data_Base_LogsDatasetinclusao';
    Data_Base_LogsDatasetinclusao.FieldName := 'inclusao';
    Data_Base_LogsDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Data_Base_LogsDatasetalteracao.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetalteracao.Name := 'Data_Base_LogsDatasetalteracao';
    Data_Base_LogsDatasetalteracao.FieldName := 'alteracao';
    Data_Base_LogsDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    Data_Base_LogsDatasetid.SetParentComponent(Data_Base_LogsDataset);
    Data_Base_LogsDatasetid.Name := 'Data_Base_LogsDatasetid';
    Data_Base_LogsDatasetid.Tag := 1;
    Data_Base_LogsDatasetid.FieldName := 'id';
    Data_Base_LogsDatasetid.Required := True;
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Data_Base_LogsDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 144;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 400;
    tmrConsulta.Top := 72;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    btnExportarExcel.AfterLoadDFMValues;
    edtAliadoNome.AfterLoadDFMValues;
    btnPesquisarAliado.AfterLoadDFMValues;
    cbbSweepExecutado.AfterLoadDFMValues;
    cbbStatus.AfterLoadDFMValues;
    Data_Base_LogsDataset.AfterLoadDFMValues;
    Data_Base_LogsDatasetdbaliadoNome_Fantasia.AfterLoadDFMValues;
    Data_Base_LogsDatasetdbaliadoCNPJ.AfterLoadDFMValues;
    Data_Base_LogsDatasetstatus.AfterLoadDFMValues;
    Data_Base_LogsDatasettransacao_inicial.AfterLoadDFMValues;
    Data_Base_LogsDatasettransacao_final.AfterLoadDFMValues;
    Data_Base_LogsDatasetdiferenca_transacao.AfterLoadDFMValues;
    Data_Base_LogsDatasetdata_coleta_log.AfterLoadDFMValues;
    Data_Base_LogsDatasetsweep_executado.AfterLoadDFMValues;
    Data_Base_LogsDatasettempo_gasto_sweep.AfterLoadDFMValues;
    Data_Base_LogsDatasetdescricao.AfterLoadDFMValues;
    Data_Base_LogsDatasetdbpath.AfterLoadDFMValues;
    Data_Base_LogsDatasetlog_gfix.AfterLoadDFMValues;
    Data_Base_LogsDatasetlog_sweep.AfterLoadDFMValues;
    Data_Base_LogsDatasetinclusao.AfterLoadDFMValues;
    Data_Base_LogsDatasetalteracao.AfterLoadDFMValues;
    Data_Base_LogsDatasetid.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
